import { DatePicker } from "antd";
import dayjs, { type Dayjs } from "dayjs";
import type { FC } from "react";

import type { AntCustomFormField, DatePickerAttributes } from "../../types/types";

interface DatePickerProps extends AntCustomFormField<string>, DatePickerAttributes {
    name: string;
    readOnly: boolean;
    placeholder?: string;
}

export const DatePickerInput: FC<DatePickerProps> = ({
    name,
    placeholder,
    value,
    onChange,
    type,
    format = "YYYY-MM-DDTHH:mm:ss.SSS[Z]",
    readOnly,
    ...restProps
}) => {
    const handleChange = (date: Dayjs | null) => {
        if (onChange) {
            const newValue = date?.format(format) ?? "";
            onChange(newValue);
        }
    };

    // Parse incoming value to match the format
    const currentValue = value ? dayjs(value, "YYYY-MM-DD") : undefined;

    return (
        <DatePicker
            name={name}
            placeholder={placeholder}
            // @ts-ignore
            value={currentValue}
            picker={type}
            // @ts-ignore
            defaultValue={currentValue}
            // @ts-ignore
            onChange={handleChange}
            disabled={readOnly}
            size="large"
            {...restProps}
        />
    );
};
